import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-select-object-type',
  templateUrl: './select-object-type.component.html',
  styleUrls: ['./select-object-type.component.scss']
})
export class SelectObjectTypeComponent {
  selectedType: string | null = null;

  constructor(public dialogRef: MatDialogRef<SelectObjectTypeComponent>) {}

  onSubmit() {
    if (this.selectedType) {
      this.dialogRef.close(this.selectedType);
    }
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
